export const COLUMN_NAMES = ["Item", "Description", "Quantity", "Unit Price","Duration","VAT/TAX" ,"Price"];
